import { render } from "./Badge.vue?vue&type=template&id=9dae650c"
import script from "./Badge.vue?vue&type=script&lang=ts"
export * from "./Badge.vue?vue&type=script&lang=ts"
script.render = render

export default script